// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3aOkg","rootSuccess":"CompleteLink_rootSuccess___jW7z","rootFailure":"CompleteLink_rootFailure__1q0om","isDisabled":"CompleteLink_isDisabled__4PfPa"};